import { render, staticRenderFns } from "./permissions-header.vue?vue&type=template&id=f0b0b4a4&scoped=true&"
var script = {}
import style0 from "./permissions-header.vue?vue&type=style&index=0&id=f0b0b4a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b0b4a4",
  null
  
)

export default component.exports